require('./index.html');
require('smartbanner.js/dist/smartbanner.min.css');
require('./assets/css/style.less');
require('./assets/img/close.png');
require('./assets/img/fullscreen.png');
require('./assets/img/logo_small.png');
require('./assets/img/add.png');
require('./assets/img/favicon.ico');
require('./assets/img/Icon64.png');
require('./assets/img/directHedgeEmailSignatur.jpg');
require('smartbanner.js/dist/smartbanner.min.js');
require('./assets/img/volume_on.png');
require('./assets/img/volume_off.png');
require('./assets/sound/new_order.wav');
require('./assets/sound/related_order_traded.wav');
require('./assets/sound/order_traded.wav');

import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import socketClient from './socket/socketClient';
import App from './screens/App';
import DefaultScreen from './screens/Default';
import Login from './screens/Login';
import ForgotPassword from './screens/ForgotPassword';
import ResetPassword from './screens/ResetPassword';
import ManageCompanies from './screens/ManageCompanies';
import ManageTabs from './screens/manageTabs';
import ManageIndices from './screens/ManageIndices';
import ManageIndicesSchedule from './screens/ManageIndicesSchedule';
import ManageCounterPartyFilter from './screens/ManageCounterPartyFilter';
import ManageFreightTypes from './screens/manageFreightTypes';
import ManageNotifications from './screens/ManageNotifications';
import ManageMarkets from './screens/markets/manageMarkets';
import OnlineMarkets from './screens/markets';
import WorkingOrders from './screens/orders/workingOrders';
import OpenPositions from './screens/orders/openPositions';
import SettledTrades from './screens/orders/settledTrades';
import SystemLog from './screens/SystemLog';
import TransactionLog from './screens/TransactionLog';
import UsersLog from './screens/UsersLog';
import TermsAndConditions from './screens/static/TermsAndConditions';
import PrivacyPolicy from './screens/static/PrivacyPolicy';
import LastTraded from './screens/orders/LastTraded';

import configureStore from './config/store';

window.React = React;
const soClient = new socketClient();
const store = configureStore(soClient);
const history = syncHistoryWithStore(browserHistory, store);
const localStorage = window.localStorage;

render(
    <Provider store={store}>
        <Router history={history}>
            <Route path="/" component={App}>
                <Route path="login" component={Login} />
                <Route path="forgot_password" component={ForgotPassword} />
                <Route path="reset" component={ResetPassword} />
                <Route
                    path="termsAndConditions"
                    title="Direct Hedge SA terms and conditions of use"
                    content={TermsAndConditions()}
                    component={DefaultScreen}
                />
                <Route
                    path="privacyPolicy"
                    title="Privacy Policy"
                    content={PrivacyPolicy()}
                    component={DefaultScreen}
                />
                <Route path="managetabs" component={ManageTabs} />
                <Route path="managecompanies" component={ManageCompanies} />
                <Route path="managecounterparty" component={ManageCounterPartyFilter} />
                <Route path="managemarkets" component={ManageMarkets} />
                <Route path="manageindices" component={ManageIndices} />
                <Route path="managedischarge" component={ManageFreightTypes} />
                <Route path="manageindicesschedule" component={ManageIndicesSchedule} />
                <Route path="managenotifications" component={ManageNotifications} />
                <Route path="onlinemarkets" component={OnlineMarkets} />
                <Route path="yourworkingorders" component={WorkingOrders} />
                <Route path="youropenpositions" component={OpenPositions} />
                <Route path="yoursettledtrades" component={SettledTrades} />
                <Route path="lasttraded" component={LastTraded} />
                <Route path="systemlog" component={SystemLog} />
                <Route path="transactionlog" component={TransactionLog} />
                <Route path="activeusers" component={UsersLog} />
            </Route>
        </Router>
    </Provider>,
    document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./source/index.js